import moment from 'moment'
import { z } from 'zod'

import { MedicalRecordStatus } from '../../modules/responsibleMedicalRecord/domain/models/MedicalRecordStatus'
import { BloodType } from './BloodType'

export const Gender = z.enum(['MALE', 'FEMALE', 'OTHER', 'DONT_WANT_TO_TELL'])
const TherapistTypeEnum = z.enum(['MANAGER'])

const ProfileResponseSchema = z.object({
  id: z.number().int(),
  name: z.string()
})

export const TherapistResponsibleSchema = z.object({
  id: z.string(),
  userId: z.string(),
  username: z.string(),
  avatarUrl: z.string(),
  type: TherapistTypeEnum,
  accessProfile: ProfileResponseSchema
})

export const PatientProfileMedicalRecord = z.object({
  id: z.string(),
  name: z.string(),
  avatar: z.string(),
  gender: Gender,
  email: z.string().email(),
  birthDay: z.string().transform((date) => moment(date).format('YYYY-MM-DD')),
  age: z.number().int(),
  height: z.number().nullable(),
  weight: z.number().nullable(),
  bloodType: BloodType.nullable(),
  therapistManagers: z.array(TherapistResponsibleSchema),
  link: z
    .object({
      uuid: z.string().nullable(),
      status: MedicalRecordStatus.nullable(),
      validate: z.string().nullable()
    })
    .nullable()
})

export type PatientProfileMedicalRecord = z.infer<
  typeof PatientProfileMedicalRecord
>
export type TherapistResponsible = z.infer<typeof TherapistResponsibleSchema>
